<template>
  <div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="提现方式">
          <el-select size="small" v-model="searchForm.type" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="银行卡" value="1"></el-option>
            <el-option label="支付宝" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品分类-->
    <!-- <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">新增渠道类目</el-button>
    </div> -->
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column type="index" width="80" align="center"></el-table-column>
      <el-table-column prop="nickname" label="昵称" width="120" align="center">
      </el-table-column>
      <el-table-column prop="card.name" label="姓名" width="120" align="center">
      </el-table-column>
      <el-table-column prop="card.mobile" label="手机号" width="120" align="center">
      </el-table-column>
      <el-table-column prop="card.identity_card" label="身份证号" width="120" align="center">
      </el-table-column>
      <el-table-column prop="card.address" label="开户行" width="120" align="center">
      </el-table-column>
      <el-table-column prop="card.number" label="银行卡号/支付宝账号" width="180" align="center">
      </el-table-column>
      <el-table-column prop="money" label="提现金额" width="120" align="center">
        <template slot-scope="scope">
          <span style="color:red">￥{{ scope.row.money }}元</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="提现方式" width="120" align="center">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.type == 1">银行卡</el-tag>
          <el-tag v-else-if="scope.row.type == 2">支付宝</el-tag>
          <el-tag type="success" v-else>暂无</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="card.type" label="支付类型" width="120" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.card.type == 1">银行卡</div>
          <div v-else-if="scope.row.card.type == 2">支付宝</div>
          <div v-else>暂不明确</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="提现类型" width="120" align="center">
        <template slot-scope="scope">
          <div style="color:green" v-if="scope.row.status == 1">提现</div>
          <div style="color:red" v-else-if="scope.row.status == 2">结算</div>
          <div v-else>暂不明确</div>
        </template>
      </el-table-column>
      <el-table-column prop="situation" label="金额状态" width="120" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.situation == 1">已到账</el-tag>
          <el-tag type="warning" v-else-if="scope.row.situation == 2">未到账</el-tag>
          <el-tag type="danger" v-else-if="scope.row.situation == 3">已拒绝</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="word" label="审核建议" width="120" align="center">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="120" align="center"> </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="150">
        <template slot-scope="scope">
		
          <el-button @click="editClick(scope.row)" type="primary" size="small"
            :disabled="scope.row.situation != 2">{{scope.row.situation != 2?'':'已'}}审核</el-button>
			
          <!-- <el-button type="text" size="small" @click="toedit(scope)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="pagination">
      <el-pagination @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize"
        layout="total, prev, pager, next" :total="totalDataNumber"></el-pagination>
    </div>
    <!--添加-->
    <Edit v-if="open_edit" :open_edit="open_edit" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
import ChannelApi from "@/api/channel.js";
import Edit from "./edit.vue";
import { deepClone } from "@/utils/base.js";
export default {
  components: {
    Edit
  },
  data() {
    return {
      /*当前编辑的对象*/
      categoryModel: {
        catList: [],
        model: {}
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 4,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        type: ""
      },
      tableData: [],
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  created() {
    this.getData();
  },
  methods: {
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      self.loading = true;
      ChannelApi.WithdrawalList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.data;

          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*选择第几页*/
    handleCurrentChange(val) { },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      console.log(e, f);
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    },
    /*打开编辑*/
    editClick(item) {
      this.userModel = deepClone(item);
      this.open_edit = true;
    },

    handleClick(row) {
      console.log(row);
    },
    /*打开添加*/
    addClick() {
      this.open_add = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/cash/cashmoney/cashrewords/index.vue